interface LogoProps {
  className?: string
}

export function Logo({ className = 'w-8 h-8' }: LogoProps) {
  return (
    <img
      src="/logo.webp"
      alt="Ruvi"
      width={44}
      height={44}
      className={className}
      draggable={false}
      decoding="async"
    />
  )
}
